export default "__VITE_ASSET__Bh3MJzGC__"